import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Redirect } from 'react-router-dom';

import { makeSelectAppLoggedIn } from '../../app/appSelectors.js';
import {isClientMobile} from "../../components/ClientInfo/ClientInfo";
import WelcomePage from './WelcomePage';
import {RouterPaths} from "../../app/appConstants";

function Welcome(props) {
    const { loggedIn, version } = props;

    if (loggedIn) {
        return <Redirect to={isClientMobile ? RouterPaths.cashier : RouterPaths.trade}/>
    }

    return <WelcomePage version={version}/>
}

const mapStateToProps = createStructuredSelector({
    loggedIn: makeSelectAppLoggedIn(),
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
